import { ChevronDown } from "lucide-react";

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  return parts.slice(0, 2).map((part) => part[0]?.toUpperCase() ?? "").join("");
}

function getFirstName(name: string): string {
  return name.trim().split(/\s+/)[0] || "Account";
}

export function UserDropdownTrigger({
  fullName,
  open,
  onClick
}: {
  fullName: string;
  open: boolean;
  onClick: () => void;
}) {
  const safeName = fullName.trim() || "Account";

  return (
    <button
      type="button"
      className="flex min-h-11 min-w-11 items-center justify-center gap-1.5 rounded-md border border-border px-1.5 py-1.5 text-sm font-medium transition hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary sm:min-w-0 sm:px-3"
      aria-expanded={open}
      aria-haspopup="menu"
      aria-label={`Open account menu for ${safeName}`}
      onClick={onClick}
    >
      <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground" aria-hidden>
        {getInitials(safeName)}
      </span>
      <span className="hidden max-w-[120px] truncate sm:inline">{getFirstName(safeName)}</span>
      <ChevronDown size={14} className="hidden shrink-0 text-muted-foreground sm:block" aria-hidden />
    </button>
  );
}
